import React from 'react'
import { MarketingCampaignDetailDto } from 'api/Trading-Accounts/Types/MarketingCampaignDetailDto'

import { CampaignDetailsRewardsPage } from './CampaignDetailsRewardsPage'
import luckyDrawRewardsColumn from './luckyDrawRewardsColumn'

interface OuterProps {
  data: MarketingCampaignDetailDto
}

const CampaignLuckyDrawDetailsRewardsPage: React.FC<OuterProps> = ({ data }) => {
  return <CampaignDetailsRewardsPage data={data} columns={luckyDrawRewardsColumn} />
}

export default CampaignLuckyDrawDetailsRewardsPage
